/* eslint-disable no-undef */
import { useEffect, useState } from 'react';
import { TextField, Button, Grid, InputAdornment, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../actions';
import PrepagoTable from './PrepagoTable';
import { checkStringsFromObject } from '../helpers';
import { useFirestore } from 'react-redux-firebase';
import axios from 'axios';
import moment from 'moment';

const PrepagoV2 = () => {
  const [prepaid, setPrepaid] = useState('');
  const [lastPrepaid, setLastPrepaid] = useState('0');
  const [monthlyIncrease, setMonthlyIncrease] = useState(0);
  const [estimativeReminders, setEstimativeReminders] = useState(0);
  const [reminderValue, setReminderValue] = useState(0);
  const [totalPrepago, setTotalPrepago] = useState(0);
  const [isFirstMonth, setIsFirstMonth] = useState(false); // pueden tener facturas, ver logica
  const [lastUpdated, setLastUpdated] = useState(false);
  const [recordatoriosALiquidar, setRecordatoriosALiquidar] = useState(false);

  const date = JSON.parse(localStorage.getItem('date'));

  // hooks
  const appDispatch = useDispatch();
  const firestore = useFirestore();
  const profile = useSelector((state) => state.firebase.profile);
  const organization = useSelector((state) => state.app.organization);

  const setChargingModal = (boolean) => {
    return appDispatch({
      type: actions.changeLoading,
      loading: { loading: boolean, priority: 1 },
    });
  };
  const setSnackBarAlert = (message, severity) => {
    return appDispatch({
      type: actions.alert,
      alert: {
        snackbarOpen: true,
        snackbarMessage: message,
        snackbarSeverity: severity,
      },
    });
  };
  useEffect(() => {
    setChargingModal(true);
    const lSPrices = JSON.parse(localStorage.getItem('prices'));
    const prepago = JSON.parse(localStorage.getItem('prepago'));
    const isFirstMonth = JSON.parse(localStorage.getItem('isFirstMonth'));
    const lastBillPrepago = JSON.parse(localStorage.getItem('lastBillPrepago'));
    const cantidadRecordatorios = JSON.parse(localStorage.getItem('recordatoriosALiquidar'));
    if (lSPrices && lSPrices.notifications) setReminderValue(lSPrices.notifications);
    else if (lSPrices && lSPrices.priceBICUtility && lSPrices.priceBICUtility.utility.length > 0) {
      lSPrices.priceBICUtility.utility.map((item) => {
        if (item.templateName === 'confirmacion/cancelacion') {
          setReminderValue(item.templatePrice);
          setRecordatoriosALiquidar(cantidadRecordatorios);
        }
      });
    }
    if (prepago && prepago.prepaid) {
      setPrepaid(prepago.prepaid);
      setMonthlyIncrease(prepago.monthlyIncrease || 0);
      setEstimativeReminders(prepago.estimativeReminders);
      setTotalPrepago(prepago.totalPrepago);
      setLastUpdated(prepago.updatedPrepagoAt);
      setLastPrepaid(prepago.lastPrepaid);
    } else if (lastBillPrepago) {
      const { estimativeReminders, monthlyIncrease, totalPrepago } = lastBillPrepago;
      estimativeReminders >= 0 && setEstimativeReminders(estimativeReminders);
      monthlyIncrease >= 0 && setMonthlyIncrease(monthlyIncrease || 0);
      totalPrepago >= 0 && setLastPrepaid(totalPrepago);
    }

    if (isFirstMonth) {
      setMonthlyIncrease(0);
      setIsFirstMonth(isFirstMonth);
    }

    setChargingModal(false);
  }, []);
  const handleInputChange = (e, state) => {
    const input = e.target.value;
    if (
      !input ||
      (input[input.length - 1].match('[0-9]') && input[0].match('[0-9]')) ||
      input[input.length - 1] === '.' ||
      input[input.length - 1] === ','
    ) {
      state(input);
    }
  };

  const fetchBillingInfo = async () => {
    try {
      const billingRes = await firestore
        .collection('bills')
        .where('organizationId', '==', organization.id)
        .where('date', '==', date)
        .get();

      if (!billingRes.empty) {
        const bill = {
          ...billingRes.docs[0].data(),
          id: billingRes.docs[0].id,
        };

        return bill;
      }
    } catch (err) {
      console.error('Error en Dashboard/hooks ===> fetchBillingInfo', err);
    }
  };

  const fetchAndFormatBillingToSend = async () => {
    const prepago = checkStringsFromObject({
      estimativeReminders,
      lastPrepaid,
      monthlyIncrease,
      reminderToLiquidate: recordatoriosALiquidar * reminderValue,
      prepaid,
      reminderValue,
      totalPrepago,
      updatedPrepagoAt: moment().toDate(),
    });
    const objectToSend = await fetchBillingInfo();
    delete objectToSend.id;
    objectToSend.prepago = prepago;
    return objectToSend;
  };

  const handleSubmit = async () => {
    const objectToSend = await fetchAndFormatBillingToSend();
    setChargingModal(true);

    try {
      await axios(`${process.env.REACT_APP_BILLING_URL}/update`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          organizationId: organization.id,
          date: objectToSend.date,
          info: objectToSend,
          requestedBy: profile.email,
        },
      });
      localStorage.setItem('prepago', JSON.stringify(objectToSend.prepago));
      setSnackBarAlert('¡Prepago actualizado exitosamente!', 'success');
    } catch (err) {
      console.log(err);
      setChargingModal(false);
      setSnackBarAlert('Ocurrio un error, intente mas tarde', 'error');
    } finally {
      setChargingModal(false);
    }
  };
  return (
    <div>
      {organization?.services?.notifications ? (
        <Grid container direction="column" alignItems="center" justifyContent="center">
          <Grid item xs={3}>
            <Typography
              style={{
                fontWeight: 'bold',
                marginBottom: 30,
                marginTop: -20,
                textAlign: 'center',
              }}
            >
              Prepago correspondiente al mes: {date ? moment(date).format('MM-YYYY') : '-'}
              <br />
              Ultima actualizacion prepago:{' '}
              {lastUpdated ? moment(lastUpdated).format('DD-MM-YYYY HH:mm') : '-'}
            </Typography>
          </Grid>
          <Grid
            item
            container
            spacing={2}
            sx={{ mb: 3 }}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={3}>
              <TextField
                label="Valor recordatorio"
                value={reminderValue}
                disabled
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>,
                }}
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Recordatorios a liquidar"
                value={(recordatoriosALiquidar * reminderValue).toFixed(2)}
                disabled
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>,
                }}
                size="small"
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid
            item
            container
            spacing={2}
            sx={{ mb: 3 }}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={3}>
              <TextField
                label="Recordatorios estimados"
                value={estimativeReminders}
                onChange={(event) => handleInputChange(event, setEstimativeReminders)}
                size="small"
                fullWidth
                type="number"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Incremento mensual"
                value={monthlyIncrease}
                InputProps={{
                  startAdornment: <InputAdornment position="start">%</InputAdornment>,
                }}
                disabled={isFirstMonth}
                onChange={(event) => handleInputChange(event, setMonthlyIncrease)}
                size="small"
                fullWidth
                type="number"
              />
            </Grid>
          </Grid>
          <Grid
            item
            container
            spacing={2}
            sx={{ mb: 3 }}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={3}>
              <TextField
                label="Prepago SIGUIENTE Manual"
                value={prepaid || 0}
                onChange={(event) => handleInputChange(event, setPrepaid)}
                size="small"
                fullWidth
                type="number"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Prepago ANTERIOR Manual"
                value={lastPrepaid}
                onChange={(event) => handleInputChange(event, setLastPrepaid)}
                size="small"
                fullWidth
                type="number"
              />
            </Grid>
          </Grid>
          <Grid item sx={{ textAlign: 'center' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              sx={{ borderRadius: '0px', minWidth: '120px', mb: 3 }}
            >
              Actualizar
            </Button>
          </Grid>
          <Grid item sx={{ textAlign: 'center' }}>
            <PrepagoTable
              estimativeReminders={estimativeReminders}
              monthlyIncrease={monthlyIncrease}
              reminderValue={reminderValue}
              isFirstMonth={isFirstMonth}
              prepaid={prepaid}
              setPrepaid={setPrepaid}
              lastPrepaid={lastPrepaid}
              setTotalPrepago={setTotalPrepago}
              recordatoriosALiquidar={recordatoriosALiquidar}
              totalPrepago={totalPrepago}
            />
          </Grid>
        </Grid>
      ) : (
        <Grid container direction="column" alignItems="center" justifyContent="center">
          <Typography align="center"> Organizacion no posee servicio de notificaciones </Typography>
        </Grid>
      )}
    </div>
  );
};

export default PrepagoV2;
